import { Component, output, TemplateRef, ViewChild } from '@angular/core';

import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-account-dropdown',
  templateUrl: './account-dropdown.component.html',
  styleUrls: ['./account-dropdown.component.scss'],
  standalone: false,
})
export class AccountDropdownComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @ViewChild(TemplateRef, { static: true }) templateRef: TemplateRef<any>;
  readonly closed = output<void>();
}
